var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.isMobile ? 'collection-social-links--mobile' : 'collection-social-links'},_vm._l((_vm.list),function(link){return _c('a',{key:link,class:_vm.isMobile ? 'collection-social-links--mobile__link' : 'collection-social-links__link',attrs:{"href":link,"target":"_blank"}},[_c(_vm.getIcon(link),{tag:"component"})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }